import ServiceBase from "@affinity/Store/ServiceBase"
import { QuantityViewModel } from "@affinity/Store/StoreTypes";
import logger from "@insite/client-framework/Logger";
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

class ServiceProducts extends ServiceBase {
    getProductById(productId: string) {
        return get<ProductModel>(`${this.productsUrl}/${productId}`, {
            expand: "properties",
            addToRecentlyViewed: true,
        } as ApiParameter);
        // Example http://localhost:3000/api/v2/products/503b01cd-302e-43f5-8e8e-aefa00abb37e?expand=properties&addToRecentlyViewed=true
        // B2B Backend Behaviour https://docs.developers.optimizely.com/commerce/v1.2.0-b2b-commerce/docs/products-apihandler
        // B2B API Docs 
        // multipleSaleQty in sub object 'detail'
        // maximumOrderQty in sub object 'properties'
    }

    getProductMaximumOrderQuantity(product: ProductModel) {
        try {
            const rawValue = product.properties[this.CustomPropertyNames.Product.maximumOrderQty];
            const mappedValue = JSON.parse(rawValue);
            return mappedValue;
        } catch (error) {
            logger.warn(`Failed to load product with expanded properties: ${error}`);
            // Fallback Behaviour TBD
            return 0;
        }
    }

    getDefaultQuantityViewModel(): QuantityViewModel {
        return {
            product: "",
            minimum: 0,
            maximum: 10000,
            increment: 250,
        };
    }

    mapToQuantityViewModel(product: ProductModel): QuantityViewModel {
        return {
            product: product?.productTitle || "",
            minimum: product?.minimumOrderQty ?? 0,
            maximum: this.getProductMaximumOrderQuantity(product),
            increment: product?.detail?.multipleSaleQty ?? 500, // NEED A DEFAULT FOR THIS
        };
    }
}

export default ServiceProducts;